import type { Locale } from '@/enums/localeEnum'
import { LocaleEnum } from '@/enums/localeEnum'

export const useDefaultPhonePrefixes = (locale: Locale) => {
  switch (locale) {
    case LocaleEnum.CZ: {
      return ['+420', '+421', '+48']
    }
    case LocaleEnum.SK: {
      return ['+421', '+420', '+48']
    }
    case LocaleEnum.PL: {
      return ['+48', '+420', '+421']
    }
    case LocaleEnum.HU: {
      return ['+36', '+48', '+420', '+421']
    }
    case LocaleEnum.RO: {
      return ['+40', '+36', '+48', '+420', '+421']
    }
    case LocaleEnum.DE: {
      return ['+49', '+43']
    }
    case LocaleEnum.AT: {
      return ['+43', '+49']
    }
    case LocaleEnum.FR: {
      return ['+33', '+32']
    }
    case LocaleEnum.IT: {
      return ['+39']
    }
    case LocaleEnum.CH: {
      return ['+41']
    }
    default: {
      return ['+420', '+421', '+48', '+36', '+40', '+49', '+43', '+33', '+39', '+41']
    }
  }
}
